module.exports = __webpack_public_path__ + "img/cintas.a1c9616c.jpeg";